import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

const LORE = {
  orion: {
    name: "Orion",
    subtitle: "The Hunter · Keeper of the Belt",
    facts: "Three belt stars — Alnitak, Alnilam and Mintaka — sit between red Betelgeuse at the shoulder and blue-white Rigel at the foot. Below the belt glows the Orion Nebula, a nursery where new stars are being born.",
    lore: "In Greek myth Orion was a giant hunter set among the stars. Ancient Egyptians saw him as Sah, linked with Osiris, lord of death and rebirth, and many link the three pyramids of Giza to his belt.",
  },
  sirius: {
    name: "Sirius",
    subtitle: "The Dog Star · Brightest in the Night Sky",
    facts: "Sirius shines in Canis Major, the Great Dog, only 8.6 light-years away. Orion's belt points down to it.",
    lore: "In Egypt Sirius was Sopdet, linked with Isis. When it first rose again before dawn each summer, it marked the Nile flood and the start of the new year — a sign of renewal and abundance.",
  },
  pleiades: {
    name: "The Pleiades",
    subtitle: "The Seven Sisters · Matariki · Subaru",
    facts: "A cluster of young, hot blue stars about 440 light-years away, wrapped in faint nebula. Orion's belt points up toward it.",
    lore: "The Greeks told of the seven daughters of Atlas. The Māori celebrate Matariki, the cluster's rising, as their new year, and in Japan it is Subaru. Across many cultures the Sisters mark the turning of the seasons.",
  },
};

export default function StarInfo({ starId, onClose }) {
  const s = starId ? LORE[starId] : null;
  return (
    <Dialog open={!!s} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        className="w-[calc(100%-2rem)] max-w-md rounded-2xl border-white/10 bg-slate-950/85 text-slate-100 backdrop-blur-xl"
        data-testid="star-info-dialog"
      >
        {s && (
          <>
            <DialogHeader>
              <p className="pr-8 font-mono text-[10px] uppercase leading-relaxed tracking-[0.3em] text-cyan-300/70">{s.subtitle}</p>
              <DialogTitle className="font-serif text-3xl font-normal tracking-wide text-white" data-testid="star-info-title">
                {s.name}
              </DialogTitle>
              <DialogDescription className="text-sm leading-relaxed text-slate-300">{s.facts}</DialogDescription>
            </DialogHeader>
            <p className="font-serif text-lg italic leading-relaxed text-slate-200" data-testid="star-info-lore">
              {s.lore}
            </p>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
